<script>
/**
 * @overview 素材-编辑Pdf
 *
 * @author MrRetro
 */
import { mapState } from "vuex";
import store from "@/store";
import mapUtils, { $http, $token, $form, $list } from "@/utils";
import FormCom from '../../../components/FormComponents/index.vue';
import { validArray } from "../../../utils/common";

export default {
  name: "EditorPdf",
  components: {
    FormCom,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    data: {
      type: Object,
      default: null,
    },
    type: [String, Number],
  },

  data: () => ({
    form: [
      {
        name: "文件上传",
        value: "",
        type: "UploadFile",
        props: {
          placeholder: "选择",
          rules: {
            required: true,
            message: "请选择",
          },
        },
      },
    ], // 上传文件表单
    imgList: [],
    formData: null,
    initData: {
    },

    loading: {
      submit: false,
    },

    rules: {
      subject_id: [$form.rules.required("学科结构", "number")],

      structure_id: [
        { required: true, validator: validArray, trigger: "blur" },
      ],
    },

    structureProps: {
      children: "leaf",
      value: "id",
      label: "name",
    },
  }),

  computed: {
    ...mapState("course", ["subjects", "structure", "themes"]),
    ...mapState({
      initList: state => state.course.initList,
    }),
    uploadHeaders() {
      return {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };
    },
    qiniuType() {
      const typeMap = {
        2: "audio",
        3: "video",
        11: "image",
        12: "image",
        13: "image",
        14: "image",
        15: "image",
        16: "image",
        21: "animation",
        51: "doc",
        41: "pdf",
      };

      return typeMap[16];
    },
    isCreate() {
      return !this.data;
    },

    knowledge: {
      get() {
        return (
                this.formData.knowledge_content &&
                this.formData.knowledge_content.split(",").join("\n")
        );
      },

      set(value) {
        this.formData.knowledge_content = value && value.split("\n").toString();
      },
    },
  },

  watch: {
    visible(value) {
      this.getUnitList();
      if (value) {
        this.init();
        this.$nextTick(this.clearValidate);
      } else {
        this.formData = null;
      }
    },
  },
  mounted() {
    this.getUnitList();
  },
  methods: {
    ...mapUtils("form", ["submit", "errorAlert"]),
    materialEdit({ url }, id) {
      console.log(11);
      this.loading.fetch = true;
      const name = url.split("/").pop();
      const uri = "/resource";
      const stru = this.formData.structure_id;
      const data = {
        ...this.formData,
        name,
        url,
        type: this.type,
        structure_id: Array.isArray(stru) ? stru[stru.length - 1] : stru,
        structure_id_str: Array.isArray(stru) ? stru.toString() : stru,
      };

      this.$form_submit({ uri, data, id }).then((res) => {
        this.$emit("success");
        this.cancel();
      }).catch((res) => {
        this.$message.error("图片资源已存在，不能上传重复图片");
      });
    },
    getImgList() {
      $http.get("/resource?page=1&equal[type]=16&per_page=20").then((res) => {
        this.imgList = res.data;
      });
    },
    modelCheckin(value, index) {
      const keys = this.findModelLocation(index);

      const lastKey = keys.pop();

      const pointer = keys
        .reduce((acc, key) => acc[key], this.theme);

      pointer[lastKey] = value;
    },
    modelCheckout(index) {
      const keys = this.findModelLocation(index);

      return keys.reduce((acc, key) => acc[key], this.theme);
    },
    // 获取所属单元列表

    getUnitList() {
      $http.get("/course/store_before").then((res) => {
        this.unitList = res.unit;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    init() {
      const data = this.data || this.initData;
      const { subject_id } = data;
      subject_id && this.querySubject(subject_id);
      if (data.structure_id_str) {
        try {
          const arr = data.structure_id_str.split(",");
          data.structure_id = arr.map(v => parseInt(v, 10));
        } catch (e) {
          console.log("处理错误==>", e);
        }
      }
      this.formData = {
        ...data,
      };

      if (data.url) {
        this.form[0].value = data.url;
      }
    },

    validate() {
      let state = false;
      this.$refs.form
        .validate((valid) => { if (valid) state = true; });
      const state1 = this.$refs.form1.validateForm();
      // console.log(state, state1);
      if (state && state1) {
        if (this.isCreate) {
          this.submit();
        } else {
          this.materialEdit({ url: this.form[0].value }, this.data.id);
        }
      }
    },

    submit() {
      this.loading.submit = true;
      const stru = this.formData.structure_id;
      this.$form_submit({
        id: this.formData.id,
        uri: "/resource",
        data: {
          ...this.formData,
          name: this.form[0].value.split('/')[this.form[0].value.split('/').length - 1],
          url: this.form[0].value,
          type: parseInt(this.type, 10),
          structure_id: Array.isArray(stru) ? stru[stru.length - 1] : stru,
          structure_id_str: Array.isArray(stru) ? stru.toString() : stru,
        },
      })
        .then(() => {
          this.$emit("success", this.formData.id);
          this.cancel();
        })
        .catch(this.$form_errorAlert)
        .finally(() => {
          this.loading.submit = false;
        });
    },

    cancel() {
      this.$emit("update:visible", false);
      this.$emit('clearData');
      this.form[0].value = '';
    },

    clearValidate() {
      this.$refs.form.clearValidate();
    },

    querySubject(subject) {
      this.$store
              .dispatch("course/initStructure", Number(subject))
              .then((structure) => {
                const query = {
                  ...this.query,
                  subject,
                  structure,
                  page: 1,
                };
              });
    },
  },
};
</script>

<template>
  <el-dialog
    v-if="formData"
    :show-close="false"
    :visible="visible"
    width="550px"
    class="course-list-editor"
  >
    <div slot="title">
      {{ isCreate ? '创建pdf' : '编辑pdf' }}
    </div>

    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="7em"
    >
      <el-form-item
        label="学科结构"
        prop="subject_id">
        <el-select
          v-model="formData.subject_id"
          @change="querySubject">
          <el-option
            v-for="subject in subjects"
            :key="subject.id"
            :label="subject.name"
            :value="subject.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="课程选择"
        prop="structure_id">
        <el-cascader
          v-model="formData.structure_id"
          :options="structure"
          :props="structureProps"
          placeholder="请选择学科以及对应课时"
        />
      </el-form-item>
    </el-form>
    <div class="upload-box">
      <FormCom
        ref="form1"
        :form="form"/>
    </div>

    <AppFormSubmit
      slot="footer"
      :submitting="loading.submit"
      @submit="validate"
      @cancel="cancel"
    />
  </el-dialog>
</template>

<style lang="postcss">
.course-list-editor .el-select {
  display: block;
}

.course-list-editor .el-dialog__body {
  padding-bottom: 10px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-form-item__content{
  display: flex;
}
.uploadImg{
  width: 160px;
  height: 160px;
  object-fit: cover;
  margin: 15px 20px;
}
.upload .dialog{
  width: 100% !important;
  height: 40px !important;
}
.upload-box{
  padding-left: 20px;
}
</style>
